import {AriadStatusBadgeComponent} from "./ariad.status-badge.component";
import {AriadVerificationComponent} from "./ariad.verification.component";
import {CreateApplicantDialogComponent} from "./result/create-applicant.dialog.component";
import {ClientUserAriadnextVerificationComponent} from "./result/client-user.ariadnext.verification.component";
import {AriadnextCheckVerificationComponent} from "./result/ariadnext-check.verification.component";

export const ARIADNEXT_VERIFICATION_COMPONENTS = [
    AriadStatusBadgeComponent,
    AriadVerificationComponent,
    CreateApplicantDialogComponent,
    ClientUserAriadnextVerificationComponent,
    AriadnextCheckVerificationComponent
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/ariadnext/index.ts